module.exports = __webpack_public_path__ + "static/img/login_form.ad34f1fd.png";